import React from 'react';
import { useParams } from 'react-router-dom';

export function SocialPostPage() {
  const { id } = useParams();
  
  return (
    <div className="flex items-center justify-center h-64">
      <p className="text-muted-foreground text-lg">Post {id} coming soon</p>
    </div>
  );
}
